module.exports = __webpack_public_path__ + "common/images/menu-selected.jpg";


//////////////////
// WEBPACK FOOTER
// ./common/images/menu-selected.jpg
// module id = 28
// module chunks = 0 1 2 3 4 5 6 7